export default __webpack_public_path__ + "static/media/bolsa.a23a3ae2.JPG";